// BureauHistorique.jsx — Historique des changements de rôle (qui a nommé qui, quand).
import { useState, useEffect } from 'react';
import { api } from '@/lib/api';
import { History, Loader2 } from 'lucide-react';

const roleLabel = (r) => ({
  president: 'Président·e',
  vice_president: 'Vice-président·e',
  secretaire: 'Secrétaire',
  tresorier: 'Trésorier·e',
  membre: 'Membre',
}[r] || (r || '').replace('_', ' '));

export default function BureauHistorique() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    api.get('/assos/bureau/historique')
      .then(({ data }) => { if (alive) setLogs(data); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, []);

  return (
    <div className="card mt-8" data-testid="bureau-historique-card">
      <div className="flex items-center gap-2 mb-1">
        <History className="w-5 h-5 text-[#475569]" />
        <h2 className="font-display text-lg font-bold text-[#0F172A]">Historique des rôles</h2>
      </div>
      <p className="text-sm text-[#475569] mb-4">Qui a désigné qui, et quand.</p>

      {loading ? (
        <div className="py-4"><Loader2 className="w-5 h-5 animate-spin text-[#94A3B8]" /></div>
      ) : logs.length === 0 ? (
        <div className="text-sm text-[#475569]" data-testid="bureau-historique-empty">
          Aucun changement de rôle pour le moment.
        </div>
      ) : (
        <ul className="divide-y divide-[#F1F5F9]" data-testid="bureau-historique-list">
          {logs.map((l) => (
            <li key={l.id} className="py-3 flex items-start gap-3">
              <div className="w-2 h-2 rounded-full bg-[#0047FF] mt-2 shrink-0" />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-[#0F172A]">
                  <strong>{l.par}</strong> a nommé <strong>{l.cible}</strong>{' '}
                  <span className="text-[#475569]">
                    {roleLabel(l.ancien_role)} → <span className="font-semibold text-[#0F172A]">{roleLabel(l.nouveau_role)}</span>
                  </span>
                </p>
                <p className="text-xs text-[#94A3B8] mt-0.5">
                  {l.date ? new Date(l.date).toLocaleString('fr-FR', { dateStyle: 'long', timeStyle: 'short' }) : ''}
                </p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
